/**
 *  Log / Report
 *   =->  현재상태 Store
 *
 *   SD-WAN 터널 상태 - 조회용 rest api 구조 차이로 인해, status.js에서 store 모듈 분리함.
 *
 *   타 기능 현재 상태 : 3가지 단계 API (start -> status -> stop). 로딩 도중, 중간 취소 가능
 *   SD-WAN 터널 상태 : (비동기 로딩 처리 없이) 1가지 조회 API (/api/lr/sdwanTunnelStatus). 중간 취소 불가
 *
 * @since 2022-11-25
 * @author wj_tams_dev01
 */

import {LogReportApiPrefix as logReportApiPreFix} from 'utils'
import {pcDownloadFile} from '~/utils/files'

export const state = () => ({
  // REST API
  apiPreFix: `${logReportApiPreFix}/sdwan/tunnelStatus`,
  // ===  onSearch ===
  dataList: [],
  selectedItem: [],
  logDetailDownErr: '',
  // SD-WAN 터널 상태 보기 요청 파라미터
  searchData: {
    filters: [],
    page_rows: 30,
    total_rows: 1000
  }
})

export const mutations = {
  // 현재 상태 보기 초기화 관련
  /**
   * 이름: initStoreData
   * 설명: 모든 스토어 데이터를 초기상태로 돌린다.
   */
  initStoreData (state) {
    // REST API 파라미터 초기화
    state.searchData = {
      filters: [],
      page_rows: 30,
      total_rows: 1000
    }
    state.dataList = []
  },
  /**
   * 이름: initDataList
   * 설명: 화면에 출력되는 데이터 테이블 모델만 초기화한다.
   */
  initDataList (state) {
    state.dataList = []
  },
  // 차트 데이터, 테이블 데이터 초기화
  errorSearch (state) {
    // REST API 파라미터 초기화
    state.searchData = {
      filters: [],
      page_rows: 30,
      total_rows: 1000
    }

    state.dataList = []
    state.logDetailDownErr = ''
  },
  setDetailDownErrMsg (state, data) {
    state.logDetailDownErr = data
  },
  // 현재 상태 보기 REST API 관련
  /**
   * 이름: appendLogDataList
   * 설명: 전달된 로그 데이터를 현재 데이터 뒤부터 붙인다.
   */
  appendLogDataList (state, newLogList) {
    for (const newLog of newLogList) {
      state.dataList.push(newLog)
    }
  },
  /**
   * 이름: updateLogDataList
   * 설명: 전달된 로그 데이터로 업데이트한다.
   */
  updateLogDataList (state, newLogList) {
    state.dataList = Object.freeze(newLogList)
  },
  /**
   * 이름: setSelectedItem
   * 설명: 현재 상태 보기 목록에서 선택된 Row 정보를 초기화한다.
   */
  setSelectedItem (state, data) {
    state.selectedItem = data
  }
}
export const actions = {
  /**
   * 이름: getSearchResult
   * 설명: SD-WAN 터널 상태를 조회한다.
   */
  async getSearchResult ({commit, state}) {
    let res = { code: 'ok', result: {} } // TAMS
    const apiUrl = `${state.apiPreFix}`

    try {
      res = await this.$axios.$post(apiUrl, state.searchData, {loading: false, successAlert: false})

      if (res.code === 'ok') {
        commit('updateLogDataList', res.result.log)
      } else {
        commit('errorSearch')
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message

      commit('errorSearch')
    }

    return res
  },
  // 파일 다운로드
  async fileSave ({state}) {
    const sendParam = _.clone(state.searchData)

    const apiUrl = `${state.apiPreFix}/download`

    const {data, fileName} = await this.$axios.$file(apiUrl, sendParam, {
      responseType: 'blob',
      successAlert: false,
      errorMsg: state.logDetailDownErr
    })
    pcDownloadFile(data, fileName)
  }
}

export const getters = {}
export const strict = false
